import { backgroundSecondaryColor, cardBorderColor, cardBackgroundColor } from "../palette";

export const MuiCard = {
  MuiCard: {
    root: {
      backgroundColor: backgroundSecondaryColor,
      border: "1px solid " + cardBackgroundColor,
    },
  },
};
